import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Keeps the kit-contents list in step with the selected variant.
 *
 * The block renders server-side off
 * `selected_or_first_available_variant.metafields.simple_bundles.bundled_variants`,
 * which is already correct for whatever variant the URL asks for. What it
 * does NOT get for free is a client-side update: on a variant change,
 * `variant-picker.js` takes the default path and calls `updateVariantPicker`,
 * which morphs the PICKER only — measured 2026-08-07, the contents list kept
 * showing Øko bomull after Lerke was selected, while the same URL fetched
 * fresh returned Lerke correctly.
 *
 * The fix is the pattern `product-inventory.js` already uses: the picker
 * dispatches a productSelect event whose promise resolves with the fully
 * fetched document, and each component pulls its own replacement out of it.
 */
class GarnpakkeInnhold extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#section()?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section()?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #section() {
    return this.closest('.shopify-section, dialog');
  }

  #handleProductSelect = (event) => {
    // A product card or quick-add dialog elsewhere on the page fires the
    // same event; only this product's own picker should redraw this list.
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const replacement = html.querySelector('garnpakke-innhold');
        // An unwired variant renders no block at all. Empty this one rather
        // than leaving the previous variant's contents on screen, which
        // would misdescribe what is in the box.
        if (!replacement) {
          this.replaceChildren();
          return;
        }

        morph(this, replacement, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[garnpakke-innhold] Event promise rejected:', error);
        }
      });
  };
}

if (!customElements.get('garnpakke-innhold')) {
  customElements.define('garnpakke-innhold', GarnpakkeInnhold);
}
